import { render } from "./TipoGrupoEquipamento.vue?vue&type=template&id=d70c1652"
import script from "./TipoGrupoEquipamento.vue?vue&type=script&lang=js"
export * from "./TipoGrupoEquipamento.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__